import type { ArtworkCardProps } from '~/components/atoms/ArtworkCard/ArtworkCard'
import ArtworksSlider from '~/components/atoms/ArtworksSlider/ArtworksSlider'
import Loader from '~/components/atoms/Loader/Loader'
import type { TSearchAnalystEventProps } from '~/services/elastic/analyst'
import { useLatestArtworks } from '~/services/query'

import styles from './LatestArtworks.module.css'

export interface LatestArtworksProps {
  currated?: ArtworkCardProps[]
  testID?: string
  offwhite?: boolean
  searchInsightsEvents?: {
    artwork: TSearchAnalystEventProps
    artist?: TSearchAnalystEventProps
  }
}

export default function LatestArtworks({
  currated,
  testID,
  searchInsightsEvents,
  offwhite = true,
}: LatestArtworksProps) {
  const { data, isLoading, insightsQueryID } = useLatestArtworks()
  const mergedData = currated && data ? [...currated, ...data] : data

  return (
    <div className={styles.base} data-testid={testID}>
      {isLoading && !currated ? (
        <div className={styles.artworks}>
          <Loader />
        </div>
      ) : (
        <ArtworksSlider
          artworks={mergedData}
          title="Art for sale"
          insightsQueryID={insightsQueryID}
          searchInsightsEvents={searchInsightsEvents}
          offwhite={offwhite}
          viewAllLink="/artworks"
        />
      )}
    </div>
  )
}
